import { Btn } from "../../../../../AbstractElements";
import { Delete, Edit, Href, Update } from "../../../../../Constants/Constants";
import { AddProjectAndUpload } from "../../../../../Data/Applications/Users/Users";

const AddProjectsAndUploadTableBody = () => {
  return (
    <tbody>
      {AddProjectAndUpload.map((data, index) => (
        <tr key={index}>
          <td className="add-project"><a className="text-inherit" href={Href}>Untrammelled Prevents</a></td>
          <td>{data.date}</td>
          <td><span className={`status-icon ${data.statusClass}`} /> {data.status}</td>
          <td>{data.price}</td>
          <td className="text-end">
            <Btn color="primary" tag="a" size="sm" href={Href}><i className="fa fa-pencil" /> {Edit}</Btn>
            <Btn color="info" tag="a" size="sm" href={Href}><i className="fa fa-link" /> {Update}</Btn>
            <Btn color="danger" tag="a" size="sm" href={Href}><i className="fa fa-trash" /> {Delete}</Btn>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default AddProjectsAndUploadTableBody;
